import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import P2pSidebar from './P2pSidebar';
import './p2p.css';

const P2pLayout = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try {
      return localStorage.getItem('p2p_sidebar_collapsed') === 'true';
    } catch {
      return false;
    }
  });

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem('p2p_sidebar_collapsed', String(next));
      } catch {}
      return next;
    });
  };

  const mainContentRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Reset scroll of the right-side content to top when navigating across P2P pages
  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <div 
      className={`p2p-layout-wrapper ${sidebarCollapsed ? 'p2p-layout-wrapper--collapsed' : ''}`}
      // style={{ backgroundImage: 'url(/images/p2p/p2pBg.png)' }}
    >
      {/* Sidebar */}
      <P2pSidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)}
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={toggleSidebarCollapse}
      />
      
      {/* Main Content */}
      <div 
        ref={mainContentRef}
        className={`p2p-main-content ${isMobile ? 'p2p-mobile' : ''}`}
      >
        {/* Mobile Header */}
        {isMobile && (
          <div className="p2p-mobile-header">
            <button 
              className="p2p-hamburger"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="p2p-hamburger-line"></span>
              <span className="p2p-hamburger-line"></span>
              <span className="p2p-hamburger-line"></span>
            </button>
            <div className="p2p-mobile-logo">
              {/* <div className="p2p-mobile-logo-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5">
                  <polyline points="22,7 13.5,15.5 8.5,10.5 2,17"/>
                  <polyline points="16,7 22,7 22,13"/>
                </svg>
              </div> */}
              {/* <span className="p2p-mobile-logo-text">Dexigo</span> */}
            </div>
            {title && <span className="p2p-page-title">{title}</span>}
            {!title && <div className="p2p-spacer"></div>}
          </div>
        )}

        {/* Page Content */}
        <div className="p2p-page-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default P2pLayout;
